import type {
  CartItemExperienceTicket,
  NexperienceVariantOption,
} from '@data-access/graphql/schema.types'
import type { NexperienceVariantFragment } from '@data-access/lib/gql/cart/documents'

import type { SelectedOptions } from '../_lib/experience-state-types'

export type VariantOption = NexperienceVariantOption & { variantId: string }

export const useExperienceOptions = (variants: NexperienceVariantFragment[] = []) => {
  const allOptions: VariantOption[] = variants.flatMap(variant =>
    variant.options.map(option => ({ ...option, variantId: variant.id }))
  )

  const getVariantOptions = (variantId: string) =>
    allOptions.filter(option => option.variantId === variantId)

  const getSelectedOptions = (tickets: CartItemExperienceTicket[]): SelectedOptions => {
    const selectedOptions: Record<string, number> = {}

    const findOptionById = (optionId: string) => allOptions.find(option => option.id === optionId)

    tickets.forEach(ticket => {
      const option = findOptionById(ticket.ticketId)
      if (!option) return

      selectedOptions[option.id] = ticket.count
    })

    return selectedOptions
  }

  return {
    allOptions,
    getSelectedOptions,
    getVariantOptions,
  }
}
